/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import logo from "../../Assets/images/logo.png";
import { MdLineStyle, MdList, MdPerson, MdShoppingCart } from "react-icons/md";
import { CiMenuBurger } from "react-icons/ci";
import { IoClose, IoMenu } from "react-icons/io5";
import config from "../../Config";
// import CartPopup from "./CartPopup";
const NewNavbar = () => {
  const [activeNav, setActiveNav] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const [CartItem, setCartitem] = useState(0);
  const Cartdata = JSON.parse(localStorage.getItem("items"));

  useEffect(() => {
    if (Cartdata && Cartdata?.length > 0) {
      setCartitem(Cartdata.length);
    } else {
      setCartitem(0);
    }
  }, [Cartdata]);

  console.log(CartItem);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setActiveNav(true);
      } else {
        setActiveNav(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`newNav ${activeNav ? "activeNav" : ""} with-banner`}>
      <div className="wrapper d-none d-xl-flex">
        <a
          rel="home"
          href="https://myhometurf.com.au/"
          title="My Home Turf"
          itemProp="url"
        >
          <img src={logo} alt="logo" className="logo" />
        </a>

        <div className="navigation d-flex gap-2">
          <ul id="main-menu" className="menu mb-0">
            <li
              id="menu-item-844"
              className="mht-general-store-item ux-menu-find-yout-turf menu-item menu-item-type-post_type menu-item-object-page menu-item-844"
            >
              <a href="https://myhometurf.com.au/find-your-turf/">
                Find Your Turf
              </a>
            </li>
            <li
              id="menu-item-844"
              className="mht-general-store-item ux-menu-find-yout-turf menu-item menu-item-type-post_type menu-item-object-page menu-item-844"
            >
              <a href="https://problemsolver.myhometurf.com.au/">
                Problem Solver
              </a>
            </li>
            <li
              id="menu-item-847"
              className="mht-general-store-item ux-menu-find-turf-suppier menu-item menu-item-type-post_type menu-item-object-page menu-item-847"
            >
              <a href="https://myhometurf.com.au/find-a-turf-supplier/">
                Find A Turf Supplier
              </a>
            </li>
            <li
              id="menu-item-846"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-846"
            >
              <a href="https://myhometurf.com.au/lawn-tips/">Lawn Tips</a>
            </li>
            <li
              id="menu-item-19259"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19259"
            >
              <a href="https://myhometurf.com.au/shop/">Online Shop</a>
            </li>
            <li
              id="menu-item-848"
              className="mht-general-store-item menu-item menu-item-type-post_type menu-item-object-page menu-item-848"
            >
              <a href="https://myhometurf.com.au/about-us/">About Us</a>
            </li>
            <li
              id="menu-item-849"
              className="navigation-btn get_quotes_now_header mht-general-store-item ux-get-three-quotes menu-item menu-item-type-post_type menu-item-object-page menu-item-849"
            >
              <a href="https://myhometurf.com.au/get-quotes-now/">
                Get 3 Quotes Now
              </a>
            </li>
          </ul>
          <div className="position-relative">
            <a
              href={`${config.appUrl}cart`}
              className="text-white ms-2"
              style={{ cursor: "pointer" }}
            >
              <MdShoppingCart size={22} />
            </a>
            {CartItem > 0 && (
              <span
                className="text-white rounded-5"
                style={{
                  backgroundColor: "#00a499",
                  width: "18px",
                  height: "18px",
                  position: "absolute",
                  bottom: "-40%",
                  left: "65%",
                  fontSize: "12px",
                  padding: "0px 6px",
                }}
              >
                {CartItem}
              </span>
            )}
          </div>
          <a
            className="text-white"
            href="https://myhometurf.com.au/my-account/"
          >
            <MdPerson size={22} />
          </a>
        </div>
        {/* {cart && <CartPopup setcart={setcart} />} */}
      </div>
      <div className="mobileNav d-block d-xl-none pt-0">
        {/* Close Button */}
        <div
          className="d-flex justify-content-between"
          style={{ height: "90px" }}
        >
          <div className="mobileLogo">
            <img src={logo} alt="logo" className="mobileLogo" />
          </div>
          <div className="d-flex justify-content-end gap-3">
            <a
              href={`${config.appUrl}cart`}
              className="text-white ms-2"
              style={{ cursor: "pointer" }}
            >
              <MdShoppingCart size={20} />
            </a>
            <a
              className="text-white"
              href="https://myhometurf.com.au/my-account/"
            >
              <MdPerson size={20} />
            </a>
            <a
              className="text-white me-4 ms-5"
              onClick={() => setMobileNav(!mobileNav)}
              role="button"
            >
              {mobileNav ? <IoClose size={28} /> : <IoMenu size={28} />}
            </a>
          </div>
        </div>
        {mobileNav && (
          <ul id="main-menu" className="menu mb-0">
            <li
              id="menu-item-844"
              className="mht-general-store-item ux-menu-find-yout-turf menu-item menu-item-type-post_type menu-item-object-page menu-item-844"
            >
              <a href="https://myhometurf.com.au/find-your-turf/">
                Find Your Turf
              </a>
            </li>
            <li
              id="menu-item-844"
              className="mht-general-store-item ux-menu-find-yout-turf menu-item menu-item-type-post_type menu-item-object-page menu-item-844"
            >
              <a href="https://problemsolver.myhometurf.com.au/">
                Problem Solver
              </a>
            </li>
            <li
              id="menu-item-847"
              className="mht-general-store-item ux-menu-find-turf-suppier menu-item menu-item-type-post_type menu-item-object-page menu-item-847"
            >
              <a href="https://myhometurf.com.au/find-a-turf-supplier/">
                Find A Turf Supplier
              </a>
            </li>
            <li
              id="menu-item-846"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-846"
            >
              <a href="https://myhometurf.com.au/lawn-tips/">Lawn Tips</a>
            </li>
            <li
              id="menu-item-19259"
              className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19259"
            >
              <a href="https://myhometurf.com.au/shop/">Online Shop</a>
            </li>
            <li
              id="menu-item-848"
              className="mht-general-store-item menu-item menu-item-type-post_type menu-item-object-page menu-item-848"
            >
              <a href="https://myhometurf.com.au/about-us/">About Us</a>
            </li>
            <li
              id="menu-item-849"
              className=" get_quotes_now_header mht-general-store-item ux-get-three-quotes menu-item menu-item-type-post_type menu-item-object-page menu-item-849"
            >
              <a href="https://myhometurf.com.au/get-quotes-now/">
                Get 3 Quotes Now
              </a>
            </li>
            <li
              id="menu-item-15402"
              className="woocommerce-item menu-item menu-item-type-post_type menu-item-object-page menu-item-15402"
            >
              <a
                href={`${config.appUrl}cart`}
                className="text-white menu-item-15403"
                style={{ cursor: "pointer" }}
              >
                Cart
              </a>
            </li>
            <li
              id="menu-item-15403"
              className="woocommerce-item menu-item menu-item-type-post_type menu-item-object-page menu-item-15403"
            >
              <a href="https://myhometurf.com.au/my-account/">My Account</a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default NewNavbar;
